import { isNumber } from 'lodash/fp';

export function truncate(string: string, length?: number): string {
    return isNumber(length) ? string.slice(0, length) : string;
}

export const isDatasetValueTruncatedByBackend = (value: string, truncationLimit: number): boolean =>
    value.length === truncationLimit && value.endsWith('…');
